module.exports = __webpack_public_path__ + "static/img/k9.e5e04fcf.png";